import PropTypes from "prop-types"
import EditIcon from "images/edit.svg";
import intl from 'react-intl-universal'
import { useGlobalContext } from 'hooks/useGlobalContext';
import { useZapmslContext } from '../../../../../context/zapmslContext';
import ButtonIcon from "components/button-icon";

const BtnEditRange = ({ openModal }) => {
  const { selectedLines } = useZapmslContext();
  const { showFeedback } = useGlobalContext();

  const handleOpenModal = () => {
    if (selectedLines.length > 0) {
      openModal()
    }
    else {
      showFeedback(intl.get('primaryMaterialScheduleList.feedbacks.mandatoryOneRecord'))
    }
  }

  return (
    <div className='btn-wrapper' title={intl.get('primaryMaterialScheduleList.modal.editRange.title')}>
      <ButtonIcon
        buttonType="secondary"
        buttonIcon={<img src={EditIcon} alt="edit-icon" />}
        className='btn-icon'
        onClick={handleOpenModal}
      />
    </div>
  )
}

BtnEditRange.propTypes = {
  openModal: PropTypes.func.isRequired
}

export default BtnEditRange;
